// Moved from src/features/upselldownsell/index.js. `name`/store key stay
// "upsellDownsell" so redux-persist and every existing selector path keep
// working unchanged. The old `upsellDownsell` array field is dropped here -
// it was written on every fetch via setUpsellDownsell but never read
// anywhere (grepped project-wide); the list page renders straight from the
// useGetAllUpsellsQuery hook's own result, same dead-mirror shape already
// found and dropped in Imports/Exports/User Management.
import { createSlice } from "@reduxjs/toolkit";
import { REHYDRATE } from "redux-persist";

const DEFAULT_SORT = "-createdAt";

const initialState = {
  selectedUpsellDownsellFilters: {
    sort: DEFAULT_SORT,
  },
};

const upsellDownsellSlice = createSlice({
  name: "upsellDownsell",
  initialState,
  reducers: {
    // ADR-F005: replace
    updateUpsellDownsellFilters(state, action) {
      state.selectedUpsellDownsellFilters = action.payload;
    },
    resetUpsellDownsellFilters(state) {
      state.selectedUpsellDownsellFilters = {
        sort: DEFAULT_SORT,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(REHYDRATE, (state, action) => {
      if (action.payload && action.payload.upsellDownsell) {
        const persistedData = action.payload.upsellDownsell;
        const persistedFilters = persistedData.selectedUpsellDownsellFilters;

        return {
          ...state,
          ...persistedData,
          selectedUpsellDownsellFilters: {
            ...(persistedFilters && typeof persistedFilters === "object"
              ? persistedFilters
              : {}),
            sort: persistedFilters?.sort || DEFAULT_SORT,
          },
        };
      }
      return state;
    });
  },
});

export const { updateUpsellDownsellFilters, resetUpsellDownsellFilters } =
  upsellDownsellSlice.actions;

export default upsellDownsellSlice.reducer;
